import { InternalURL } from "./internal-url";

export function createTagPageURL(tag: string) {
  const path = "/posts";
  const searchParams = new URLSearchParams([["tag", tag]]);

  return new InternalURL(path, searchParams);
}
